import React, {Component} from 'react';
import Picker from '../widgets/Picker';
import createPauser from '../pauser';
import {connect} from 'react-redux';

/**
 * Category drop down that executes a search on the internal list of categories
 */
class CategoryPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: []
		};

		this.performSearch = createPauser(async search => {
			if (this.props.providerCategories) {
				this.setState({
					items: search
						? this.props.providerCategories.filter(
								item => item.value.toLowerCase().indexOf(search.toLowerCase()) >= 0
						  )
						: this.props.providerCategories
				});
			}
		}, 100);
		this.onSearchChange = e => this.performSearch(e.target.value);
	}

	render() {
		return (
			<Picker
				loading={this.state.loading}
				title="Choose a location"
				searchPlaceholder="Search for a category"
				onChangeSearch={this.onSearchChange}
				items={
					this.state.items && this.state.items.length
						? this.state.items
						: this.props.providerCategories
				}
			/>
		);
	}
}

const ConnectedCategoryPicker = connect(({categories}) => ({
	providerCategories:
		categories && categories.provider.map(category => ({value: category, label: category}))
}))(CategoryPicker);

export default ConnectedCategoryPicker;



// WEBPACK FOOTER //
// ./src/search/CategoryPicker.js